const recommendations = {
  Performance: 0,
  HighPerformance: 1,
  ExtremePerformance: 2,
  Custom: 3
};

export { recommendations };
